module.exports = __webpack_public_path__ + "img/home_banner_pc.b8f59fc2.webp";